import React from "react";

const ACCENT = "#1b4d2e";

// Selector de espacios en chips. Compartido por el calendario (alta y edición
// de evento) y por leads (espacios de interés y conversión), para que la misma
// decisión se capture igual en todos lados.
//
// `opciones` son entradas del rollup ({ id, nombre }) — el call site decide
// cuáles ofrece (normalmente los activos y reservables, más los que el
// registro ya traía aunque hoy estén inactivos, para poder quitarlos).
// Selección vacía ⇒ TODO EL VENUE, nunca "no ocupa nada" (contrato de
// utils/espacios.js).
export default function EspaciosPicker({
  opciones = [],
  value = [],
  onChange,
  disabled = false,
  size = "md",
}) {
  const chip =
    size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";

  const toggle = (id) => {
    if (disabled) return;
    onChange(
      value.includes(id) ? value.filter((x) => x !== id) : [...value, id]
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {opciones.map((esp) => {
        const seleccionado = value.includes(esp.id);
        return (
          <button
            key={esp.id}
            type="button"
            onClick={() => toggle(esp.id)}
            disabled={disabled}
            aria-pressed={seleccionado}
            className={`rounded-lg border font-medium transition disabled:opacity-50 disabled:cursor-not-allowed ${chip} ${
              seleccionado
                ? "border-transparent text-white"
                : "border-zinc-200 dark:border-zinc-700 text-zinc-700 dark:text-zinc-300 bg-white dark:bg-zinc-800 hover:bg-zinc-50 dark:hover:bg-zinc-700"
            }`}
            style={seleccionado ? { backgroundColor: ACCENT } : undefined}
          >
            {esp.nombre}
          </button>
        );
      })}
    </div>
  );
}
